import { Component, Input, HostBinding, OnChanges } from '@angular/core';

@Component({
  selector: 'app-operator',
  templateUrl: './operator.component.pug',
  styleUrls: ['./operator.component.less']
})
export class OperatorComponent implements OnChanges {
  @Input() level;

  @HostBinding('class.skin1') skin1 = true;
  @HostBinding('class.skin2') skin2 = true;
  @HostBinding('class.skin3') skin3 = true;
  @HostBinding('class.skin4') skin4 = true;

  constructor() {
  }

  ngOnChanges() {
    if (!Number.isInteger(this.level)) {
      return;
    }

    this.skin1 = this.level >= 1;
    this.skin2 = this.level >= 7;
    this.skin3 = this.level >= 13;
    this.skin4 = this.level >= 19;
  }
}
